{
  "nav": {
    "home": "Startseite",
    "silos": "Silos",
    "skills": "Skills",
    "arena": "Arena",
    "aiPowered": "KI-gestützt",
    "knowledgeFlows": "Wissen fließt intelligent durch Ihre Organisation.",
    "askTheKnowledgeBase": "Fragen Sie die Wissensdatenbank",
    "ask": "Fragen",
    "help": "Hilfe",
    "logout": "Abmelden",
    "signIn": "Anmelden",
    "openProfileInMe": "Ihr Profil in JoyIA Me"
  },
  "common": {
    "loading": "Lädt...",
    "error": "Fehler",
    "save": "Speichern",
    "saving": "Wird gespeichert...",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "hide": "Ausblenden",
    "create": "Erstellen",
    "search": "Suchen",
    "filter": "Filtern",
    "refresh": "Aktualisieren",
    "close": "Schließen",
    "back": "Zurück",
    "next": "Weiter",
    "previous": "Zurück",
    "submit": "Absenden",
    "confirm": "Bestätigen",
    "yes": "Ja",
    "no": "Nein",
    "all": "Alle",
    "none": "Keine",
    "select": "Auswählen",
    "viewAll": "Alle anzeigen",
    "remove": "Entfernen",
    "add": "Hinzufügen",
    "new": "Neu",
    "success": "Erfolg",
    "warning": "Warnung",
    "info": "Information",
    "noResults": "Keine Ergebnisse gefunden",
    "noData": "Verwalten Sie Ihre Wissenssilos und suchen Sie über alle Inhalte hinweg",
    "clear": "Leeren",
    "sync": "Synchronisieren",
    "item": "Element",
    "items": "Elemente",
    "copied": "Kopiert!"
  },
  "silos": {
    "title": "Silos",
    "description": "Wissensdatenbanken und Dokumentsammlungen",
    "createNew": "Neues Silo erstellen",
    "editSilo": "Silo bearbeiten",
    "deleteSilo": "Silo löschen",
    "siloSettings": "Silo-Einstellungen",
    "knowledge": "Wissen",
    "project": "Projekt",
    "timeline": "Zeitleiste",
    "sync": "Synchronisieren",
    "syncHistory": "Synchronisierungsverlauf",
    "connectors": "Konnektoren",
    "statusLabel": "Status",
    "idle": "Untätig",
    "running": "Wird ausgeführt",
    "pending": "Ausstehend",
    "error": "Fehler",
    "newSilo": "Neues Silo",
    "createSilo": "Silo erstellen",
    "myKnowledgeBase": "Meine Wissensbasis",
    "sortByName": "Name (A–Z)",
    "sortByCreated": "Zuletzt erstellt",
    "heading": "Wissenssilos",
    "unitCountSingular": "{{n}} Silo",
    "unitCountPlural": "{{n}} Silos",
    "itemCountSingular": "{{n}} Element",
    "itemCountPlural": "{{n}} Elemente",
    "memberCountSingular": "{{n}} Mitglied",
    "memberCountPlural": "{{n}} Mitglieder",
    "searchPlaceholder": "Silos suchen...",
    "noMatches": "Keine Silos passen zu “{{search}}”",
    "emptyTitle": "Noch keine Wissenssilos",
    "emptyBody": "Erstelle dein erstes Silo, um deine Wissensbasis aufzubauen"
  },
  "skills": {
    "title": "Skills",
    "description": "Fähigkeiten und Möglichkeiten",
    "createNew": "Neue Fähigkeit erstellen",
    "editSkill": "Fähigkeit bearbeiten",
    "deleteSkill": "Fähigkeit löschen",
    "arena": "Arena",
    "skillDetails": "Fähigkeitsdetails",
    "knowledge": "Wissen",
    "project": "Projekt",
    "mine": "Meine Skills",
    "unitCountSingular": "{{n}} Skill",
    "unitCountPlural": "{{n}} Skills",
    "newSkill": "Neue Skill",
    "searchPlaceholder": "Skills suchen…",
    "allCategories": "Alle Kategorien",
    "emptyTitle": "Keine Skills gefunden",
    "emptyBody": "Erstelle deine erste Skill oder importiere eine von GitHub oder skills.sh",
    "sharedWithTribes": "Mit Tribes geteilt",
    "thisTribeHint": "Mit diesem Tribe geteilte Skills. Öffne einen Skill, um die Installationsanleitung zu sehen.",
    "sharedTribesHint": "Skills, die mit deinen Tribes geteilt wurden. Öffne einen Skill, um die Installationsanleitung zu sehen.",
    "showAllTribes": "Alle meine Tribes anzeigen",
    "loadFailed": "Skills konnten nicht geladen werden. Lade die Seite bitte neu.",
    "sharedEmptyBody": "Hier wurden noch keine Skills geteilt. Bitte ein Tribe-Mitglied, einen Skill zu teilen.",
    "categoryEmptyBody": "Keine Skills passen zur Kategorie „{{category}}“.",
    "allSkills": "Alle Skills",
    "collections": "Skill-Sammlungen",
    "allSources": "Alle Quellen",
    "source": "Quelle",
    "noMatchesBody": "Versuche eine andere Suche oder entferne deine Filter.",
    "clearFilters": "Filter entfernen"
  },
  "visibility": {
    "private": "Privat",
    "privateDesc": "Nur Sie können darauf zugreifen",
    "orgVisible": "Organisation sichtbar",
    "orgVisibleDesc": "Jeder in Ihrer Organisation",
    "restricted": "Eingeschränkt",
    "restrictedDesc": "Personen, die Sie einladen",
    "tribe": "Tribe",
    "tribeDesc": "Alle Mitglieder eines Tribes",
    "label": "Sichtbarkeit",
    "public": "Öffentlich"
  },
  "classification": {
    "unclassified": "Nicht klassifiziert",
    "confidential": "Vertraulich",
    "strictlyConfidential": "Streng vertraulich"
  },
  "sources": {
    "github": "GitHub",
    "internal": "Intern",
    "skillSh": "skills.sh"
  },
  "ask": {
    "title": "Fragen",
    "askAboutThisSilo": "Fragen Sie zu diesem Silo… (Eingabe zum Senden)",
    "askAcrossAllSilos": "Fragen Sie über alle Silos… (Eingabe zum Senden)",
    "askAboutKnowledgeflow": "Fragen Sie zu Knowledgeflow… (Eingabe zum Senden)",
    "askAQuestion": "Stellen Sie eine Frage zu dieser Wissensdatenbank...",
    "phAsk": "Über alle Silos hinweg fragen… (Enter zum Senden, Shift+Enter für eine neue Zeile)",
    "synthesised": "Die Antworten werden mit KI-gestützter Suche aus den Wissenssilos erzeugt, auf die Sie Zugriff haben",
    "strategySearch": "{{strategy}}-Suche"
  },
  "settings": {
    "movedToMe": "Ihr Profil befindet sich jetzt in JoyIA Me. Sie werden weitergeleitet…",
    "movedToMeNoUrl": "Ihr Profil befindet sich jetzt in JoyIA Me."
  },
  "errors": {
    "failed": "Fehler: {{message}}"
  },
  "forms": {
    "required": "Erforderlich",
    "optional": "Optional",
    "selectOne": "Wählen Sie eines aus...",
    "selectMultiple": "Wählen Sie mehrere aus...",
    "enterText": "Text eingeben...",
    "enterNumber": "Geben Sie eine Zahl ein...",
    "chooseFile": "Datei auswählen...",
    "dragDropFiles": "Ziehen Sie Dateien hierher",
    "or": "oder",
    "browseFiles": "Dateien durchsuchen",
    "description": "Beschreibung"
  },
  "pagination": {
    "previous": "Zurück",
    "next": "Weiter",
    "of": "von",
    "page": "Seite",
    "rowsPerPage": "Zeilen pro Seite"
  },
  "dialogs": {
    "confirmDelete": "Löschung bestätigen",
    "areYouSure": "Möchten Sie dieses Element wirklich löschen?",
    "thisCannotBeUndone": "Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen"
  },
  "empty": {
    "noSilos": "Noch keine Silos",
    "noSkills": "Noch keine Fähigkeiten",
    "noResults": "Keine Ergebnisse gefunden"
  },
  "home": {
    "searchPlaceholder": "In allen Silos suchen...",
    "noSearchResults": "Keine Ergebnisse gefunden",
    "totalItems": "Elemente insgesamt",
    "totalMembers": "Mitglieder insgesamt",
    "recentSilos": "Aktuelle Silos",
    "noSilos": "Noch keine Silos.",
    "createOne": "Eines erstellen",
    "recentItems": "Aktuelle Wissenselemente",
    "knowledgeHealth": "Zustand der Wissensbasis",
    "noItemsFromSource": "Keine Elemente aus dieser Quelle"
  },
  "siloView": {
    "abstractSaved": "Zusammenfassung gespeichert",
    "abstractSaveFailed": "Speichern der Zusammenfassung fehlgeschlagen: {{message}}",
    "siloUpdated": "Silo aktualisiert",
    "siloUpdateFailed": "Silo-Update fehlgeschlagen: {{message}}",
    "syncFailed": "Synchronisierung konnte nicht gestartet werden: {{message}}",
    "generatingAbstractBackground": "Zusammenfassung wird im Hintergrund generiert…",
    "abstractDrafted": "Zusammenfassung entworfen — überprüfen und speichern",
    "abstractGenerateFailed": "Generierung der Zusammenfassung fehlgeschlagen: {{message}}",
    "editSilo": "Silo bearbeiten",
    "members": "Mitglieder",
    "config": "Konfiguration",
    "syncHistory": "Synchronisierungsverlauf",
    "treeView": "Baumansicht",
    "mergeSilo": "Silo zusammenführen",
    "triggerSync": "Synchronisierung jetzt starten",
    "syncing": "Wird synchronisiert…",
    "abstractPlaceholder": "Schreiben Sie eine kurze Zusammenfassung des Inhalts dieses Silos...",
    "editAbstract": "Zusammenfassung bearbeiten",
    "regenerateWithAI": "Mit KI neu generieren",
    "generatingAbstract": "Zusammenfassung wird generiert…",
    "addSummary": "+ Fügen Sie eine Zusammenfassung für dieses Silo hinzu...",
    "generate": "Generieren",
    "generateWithAI": "Zusammenfassung mit KI generieren",
    "cliSetupInstructions": "CLI-Einrichtungsanweisungen",
    "itemsInSilo": "{{count}} Elemente in diesem Silo",
    "cliProjectSilo": "CLI-gestütztes Projektsilo",
    "linkSiloToProject": "Verbinden Sie dieses Silo mit einem Projektverzeichnis, damit Ihre KI-Agenten während der Entwicklung lesen und schreiben können.",
    "step1": "1. Mit Ihrem Projekt verbinden",
    "runInProjectDir": "Führen Sie diesen Befehl in Ihrem Projektverzeichnis aus, um dieses Silo zu verbinden.",
    "step2": "2. Synchronisieren Sie Ihre Projektdateien",
    "syncDescription": "Erfasst Ihren Projektkontext (README, Dokumentation, Konfiguration) in diesem Silo. Idempotent — unveränderte Dateien werden übersprungen.",
    "step3": "3. Eine einzelne Notiz versenden",
    "pushDescription": "Fügt ein Element hinzu. Beide Argumente sind erforderlich — oder geben Sie eine Datei als Inhalt weiter:",
    "step4": "4. Mit KI-Agenten verwenden",
    "aiAgentsDescription": "Nach der Verbindung können KI-Codierungsagenten (Claude Code, OpenCode usw.) automatisch auf die Kenntnisse dieses Silos über den MCP-Server zugreifen.",
    "state_active": "Aktiv",
    "state_paused": "Pausiert",
    "state_archived": "Archiviert",
    "lastSync": "Letzte Synchronisierung: {{time}}",
    "syncOverdue": "Synchronisierung überfällig",
    "nextSync": "Nächste Synchronisierung in {{label}}",
    "source": "Quelle",
    "sortNewest": "Neueste zuerst",
    "sortImportance": "Höchste Wichtigkeit",
    "sortAccessed": "Am häufigsten zugegriffen",
    "noItemsYet": "Noch keine Wissenselemente",
    "noItemsHelp": "Fügen Sie Elemente manuell hinzu oder konfigurieren Sie Synchronisierungsquellen",
    "noItemsOfType": "Keine {{type}}-Elemente gefunden",
    "clearFilter": "Filter löschen",
    "mergeDialog": "Ein anderes Silo in diesen zusammenführen",
    "mergeDescription": "Alle Elemente aus dem ausgewählten Silo werden in {{name}} verschoben.",
    "sourceSilo": "Quellsilo",
    "selectSiloMerge": "Wählen Sie ein Silo zum Zusammenführen...",
    "deleteSourceAfterMerge": "Quellsilo nach dem Zusammenführen löschen",
    "mergeSuccess": "{{count}} Elemente erfolgreich zusammengeführt.{{deleted}}",
    "mergeFailed": "Zusammenführen fehlgeschlagen: {{message}}",
    "merging": "Wird zusammengeführt...",
    "merge": "Zusammenführen",
    "editSiloDialog": "Silo bearbeiten",
    "tags": "Tags (durch Komma getrennt)",
    "publicSilo": "Öffentliches Silo",
    "publicSiloDescription": "Alle Benutzer Ihrer Organisation können dieses Silo lesen",
    "guardrailProfiles": "Guardrail-Profile",
    "guardrailDescription": "Gilt für alle LLM-Aufrufe, die den Inhalt dieses Silos verarbeiten",
    "linkToProject": "Mit Projekt verlinken (CLI)",
    "linkSharedSilo": "Als gemeinsames Silo verlinken",
    "attachSiloDescription": "Heften Sie dieses Silo als {{role}} an ein Projektverzeichnis an, neben dem Hauptsilo des Projekts. Schreibgeschützt verlinkt — KI-Agenten können es lesen, aber Schreibvorgänge gehen an das Hauptsilo des Projekts.",
    "timelineSiloLabel": "ein gemeinsames \"Timeline\"-Silo (aktuelle Aktivität)",
    "knowledgeSiloLabel": "ein gemeinsames \"Wissens\"-Silo",
    "linkLimits": "Ein Projekt kann ein Hauptsilo plus bis zu 5 schreibgeschützte verlinken (eines für Wissen, eines für Timeline, plus zusätzliche schreibgeschützte Silos).",
    "healthAllClear": "Wissenszustand: alles in Ordnung",
    "avgImportance": "Durchschnittliche Wichtigkeit: {{value}}",
    "staleItem": "Element",
    "staleItems": "Elemente",
    "conflict": "Konflikt",
    "multiConflicts": "Konflikte",
    "archiveStale": "{{count}} abgelaufene archivieren",
    "archiveConfirm": "{{count}} Elemente archivieren?",
    "runInProjectDirLabel": "Im Projektverzeichnis ausführen",
    "staleItemsLabel": "Elemente",
    "staleItemsList": "{{count}} abgelaufene {{type}}",
    "archivedStale": "{{count}} veraltete Einträge archiviert",
    "conflicts": "{{count}} {{type}}"
  },
  "siloHealth": {
    "authExpiredTitle": "Ein Connector kann sich nicht mehr anmelden",
    "authExpiredBody": "Die gespeicherten Zugangsdaten für {{sources}} sind abgelaufen — meist, weil das Passwort des verbundenen Kontos geändert wurde. Bis die Quelle neu verbunden wird, erreichen keine neuen Inhalte dieses Silo.",
    "syncFailingTitle": "Ein Connector kann nicht synchronisieren",
    "syncFailingBody": "Die letzte Synchronisierung von {{sources}} ist fehlgeschlagen, daher erreichen keine neuen Inhalte dieses Silo.",
    "openSyncSettings": "Sync-Einstellungen öffnen",
    "unindexedTitle": "Die Inhalte dieses Silos sind nicht durchsuchbar",
    "thinTitle": "Nur ein Teil dieses Silos ist durchsuchbar",
    "coverageBody": "{{indexed}} von {{total}} Elementen sind im Suchindex ({{pct}} %). Fragen an dieses Silo — auch von einer damit verbundenen Website — werden nur aus diesem Teil beantwortet, ohne dass ein Fehler gemeldet wird.",
    "rebuildIndex": "Index in den Sync-Einstellungen neu aufbauen"
  },
  "chart": {
    "noData": "Keine Daten vorhanden",
    "fullscreen": "Vollbild",
    "expandedFullscreen": "Diagramm im Vollbild",
    "closeFullscreen": "Vollbild schließen"
  },
  "apps": {
    "title": "Apps & Quellen",
    "description": "Wissenselemente nach der Quelle durchsuchen, die sie erstellt hat",
    "noItems": "Noch keine Wissenselemente",
    "lastUsed": "Zuletzt verwendet"
  },
  "skillShare": {
    "title": "Skill teilen",
    "description": "Lege fest, wer diese Skill sehen und installieren kann.",
    "visibilitySet": "Sichtbarkeit auf {{value}} gesetzt",
    "updateFailed": "Sichtbarkeit konnte nicht aktualisiert werden: {{message}}",
    "selectTribes": "Wähle die Tribes, die diese Skill sehen können",
    "noTribes": "Keine Tribes verfügbar",
    "selectAtLeastOne": "Wähle mindestens einen Tribe zum Speichern"
  },
  "skillDetail": {
    "installTracked": "Installation erfasst",
    "refreshedFiles": "Aus der Quelle aktualisiert — {{n}} Dateien",
    "refreshedNewFilesSingular": "Aktualisiert — {{n}} neue mitgelieferte Datei aus der Quelle",
    "refreshedNewFilesPlural": "Aktualisiert — {{n}} neue mitgelieferte Dateien aus der Quelle",
    "refreshedFromSource": "Aus der Quelle aktualisiert",
    "skillDeleted": "Skill gelöscht",
    "skillUpdated": "Skill aktualisiert",
    "share": "Share",
    "refreshing": "Refreshing…",
    "refresh": "Refresh",
    "skillNotFound": "Skill nicht gefunden",
    "backToSkills": "Zurück zu Skills",
    "public": "Public",
    "sharedWithTribe": "Mit dem Tribe geteilt",
    "private": "Private",
    "installs": "installs",
    "skillAdded": "Skill hinzugefügt!",
    "wantToTestInArena": "Möchten Sie sehen, wie er sich in der Arena schlägt?",
    "testInArena": "In der Arena testen",
    "editSkill": "Skill bearbeiten",
    "name": "Name",
    "version": "Version",
    "description": "Description",
    "content": "Content",
    "categories": "Categories",
    "extraTags": "Zusätzliche Tags",
    "commaSeparated": "durch Kommas getrennt",
    "tagsPlaceholder": "swiftui, performance",
    "visibility": "Visibility",
    "saving": "Saving…",
    "saveChanges": "Änderungen speichern",
    "pluginCapabilities": "Plugin-Funktionen",
    "providesTools": "Stellt Werkzeuge bereit",
    "dependencies": "Dependencies",
    "readinessCheck": "Bereitschaftsprüfung",
    "requiredEnvironment": "Erforderliche Umgebung",
    "required": "Required",
    "nightWatchHooks": "Night-Watch-Hooks",
    "notEvaluatedYet": "Noch nicht bewertet",
    "runThroughArena": "Lassen Sie diesen Skill durch die Arena laufen, um zu bewerten, wie gut ein Modell ihm folgt.",
    "runArenaTest": "Arena-Test ausführen",
    "arenaScore": "Arena Score",
    "testAgain": "Erneut testen",
    "evaluations": "evaluation",
    "lastTested": "zuletzt getestet",
    "hideHistory": "Verlauf ausblenden",
    "showAllEvaluations": "Alle {{n}} Bewertungen anzeigen",
    "useThisSkill": "Diesen Skill verwenden",
    "files": "files",
    "copyCommand": "Befehl kopieren",
    "writesSKillMd": "Schreibt SKILL.md plus",
    "bundledFile": "gebündelte Datei",
    "copyingGivesYou": "— wenn Sie den Inhalt unten kopieren, erhalten Sie nur SKILL.md.",
    "copySKillMd": "SKILL.md kopieren",
    "tracking": "Tracking…",
    "trackInstall": "Installation erfassen",
    "preferredJoyiaCli": "Empfohlen — Joyia CLI",
    "setup": "Setup",
    "copy": "Copy",
    "opensInteractiveSkillBrowser": "Öffnet den interaktiven Skill-Browser. Drücken Sie",
    "toInstall": "zum Installieren.",
    "installsFromSkillsSh": "Installiert von skills.sh — kein Joyia-Konto erforderlich.",
    "installFromJoyiaMarketplace": "Über die ID aus dem Joyia-Marktplatz installieren.",
    "manualInstall": "Manuelle Installation (ohne Joyia CLI)",
    "install": "Install",
    "cliTab": "CLI",
    "personalTab": "Personal",
    "projectTab": "Project",
    "npxSkillsInstall": "npx skills install",
    "npxSkillsAdd": "npx skills add",
    "step1AddMarketplace": "Schritt 1 — Marktplatz hinzufügen",
    "step2InstallPlugin": "Schritt 2 — Plugin installieren",
    "copyJSON": "JSON kopieren",
    "skillContent": "Skill-Inhalt",
    "copyRaw": "Rohfassung kopieren",
    "noContent": "_No content_",
    "bundledFiles": "Gebündelte Dateien",
    "alongsideSKillMd": "neben SKILL.md",
    "collapse": "Collapse",
    "expand": "Expand",
    "deleting": "Deleting…",
    "confirmDelete": "Löschen bestätigen"
  },
  "sharepoint": {
    "connected": "Mit Microsoft SharePoint verbunden",
    "signInFailed": "Anmeldung fehlgeschlagen",
    "completingSignIn": "Microsoft-Anmeldung wird abgeschlossen…",
    "redirecting": "Verbunden — wird umgeleitet…",
    "error": "Anmeldung fehlgeschlagen",
    "backToSilos": "Zurück zu Silos"
  },
  "auth": {
    "subtitle": "Persistenter Speicher für Ihre KI-Agenten und Entwicklungs-Workflows",
    "signInWithPia": "Mit PIA anmelden"
  },
  "askPanel": {
    "search": "Suchen",
    "ask": "Fragen",
    "searchFailed": "Suche fehlgeschlagen",
    "failedToGetAnswer": "Antwort konnte nicht abgerufen werden",
    "semanticSearchPlaceholder": "Semantische Suche...",
    "focusInTree": "Im Baum fokussieren",
    "askPlaceholder": "Stellen Sie eine Frage zu dieser Wissensdatenbank...",
    "answer": "Antwort",
    "sources": "Quellen",
    "resultCountSingular": "{{n}} Ergebnis",
    "resultCountPlural": "{{n}} Ergebnisse"
  },
  "skillsArena": {
    "title": "Skills Arena",
    "description": "Skills testen und vergleichen — Ergebnisse werden gespeichert und bewertet",
    "evaluateLabel": "Skill evaluieren",
    "selectSkill": "Wählen Sie eine Skill aus dem Katalog oder den Rankings unten aus, um sie zu evaluieren.",
    "testPromptLabel": "Test-Prompt",
    "testPromptPlaceholder": "Geben Sie einen Test-Prompt ein...",
    "evaluating": "Evaluierung läuft... (kann 30-60s dauern)",
    "evaluateButton": "Skill evaluieren",
    "scoreMax": "Punktzahl / 100",
    "adherenceMax": "Einhaltung / 10",
    "duration": "Dauer",
    "criteria": "Kriterien",
    "generatedOutput": "Generierte Ausgabe",
    "model": "Modell",
    "judge": "Richter",
    "savedToRankings": "In Rankings gespeichert",
    "viewInLibrary": "In Bibliothek anzeigen",
    "skillCatalog": "Skill-Katalog",
    "rankings": "Rankings",
    "searchCatalog": "Katalog durchsuchen...",
    "noSkillsMatch": "Keine Skills entsprechen Ihren Filtern.",
    "noEvaluations": "Noch keine Evaluierungen",
    "runFirstEvaluation": "Führen Sie Ihre erste Arena-Evaluierung durch, um die Bestenliste zu erstellen.",
    "skill": "Skill",
    "avgScore": "Durchschn. Punktzahl",
    "tests": "Tests",
    "lastRun": "Letzte Ausführung",
    "librarySkill": "Bibliotheks-Skill"
  },
  "itemView": {
    "itemSaved": "Element gespeichert",
    "failedToSave": "Speichern fehlgeschlagen",
    "memoryArchived": "Speicher archiviert",
    "memoryRestoredToActive": "Speicher als aktiv wiederhergestellt",
    "memoryPaused": "Speicher unterbrochen — aus der Suche ausgeblendet",
    "failedToUpdateState": "Status-Update fehlgeschlagen",
    "itemDeleted": "Element gelöscht",
    "failedToDelete": "Löschen fehlgeschlagen",
    "staleWarning": "Dieses Element könnte veraltet sein — als Abfall markiert durch Wartung",
    "conflictDetected": "Konflikt erkannt",
    "viewConflictingItem": "konflikt bereinigendes Element anzeigen",
    "conflictResolved": "Konflikt gelöst — beide Elemente behalten",
    "keepBoth": "Beide Behalten",
    "conflictResolvedOtherArchived": "Konflikt gelöst — anderes Element archiviert",
    "keepThisArchiveOther": "Dies Behalten, Anderes Archivieren",
    "thisItemArchived": "Dieses Element wurde archiviert",
    "archiveThis": "Dies Archivieren",
    "tagsLabel": "Tags (kommagetrennt)",
    "tagsPlaceholder": "tag1, tag2",
    "contentLabel": "Inhalt",
    "relatedMemories": "Verwandte Speicher",
    "deleteItemTitle": "Dieses Element löschen?",
    "deleteItemDescription": "Dies kann nicht rückgängig gemacht werden. Das Wissensobjekt und der gesamte Inhalt werden dauerhaft entfernt.",
    "deleting": "Wird gelöscht...",
    "projectLabel": "Projekt",
    "typeLabel": "Typ",
    "statusLabel": "Status",
    "priorityLabel": "Priorität",
    "assigneeLabel": "Zugeordnet an",
    "versionLabel": "Version",
    "summarised": "Zusammengefasst",
    "used": "Verwendet",
    "timesSingular": "mal",
    "timesPlural": "mal",
    "importanceHigh": "hohe Relevanz",
    "importanceMedium": "mittlere Relevanz",
    "moreOptions": "Weitere Optionen",
    "restoreToActive": "Als Aktiv Wiederherstellen",
    "pause": "Unterbrechen",
    "archive": "Archivieren"
  },
  "syncHistory": {
    "heading": "Synchronisierungsverlauf",
    "backToSilo": "Zurück zum Silo",
    "noJobs": "Noch keine Synchronisierungsvorgänge",
    "cancelled": "Synchronisierung abgebrochen — aktueller Batch wird beendet",
    "finalising": "Wird finalisiert…",
    "sourcePagesTip": "Quelleseiten gescannt — entspricht nicht derselben Anzahl wie hinzugefügte Elemente",
    "src": "src",
    "itemsCreatedTip": "Neue Elemente zum Silo hinzugefügt",
    "itemsUpdatedTip": "Vorhandene Elemente aktualisiert",
    "itemsSkippedTip": "Unveränderte Elemente übersprungen",
    "itemsDeletedTip": "Elemente aus Silo entfernt",
    "stopSync": "Synchronisierung stoppen",
    "jobId": "Auftrags-ID",
    "parentSync": "Übergeordnete Synchronisierung",
    "triggeredBy": "Ausgelöst von",
    "duration": "Dauer",
    "since": "Seit",
    "sinceLower": "seit",
    "items": "Elemente",
    "new": "neu",
    "updated": "aktualisiert",
    "unchanged": "unverändert",
    "deleted": "gelöscht",
    "refused": "Abgelehnt",
    "refusedTitleSingular": "{{n}} Datei nicht indiziert — die Vertraulichkeitsbezeichnung verbietet es",
    "refusedTitlePlural": "{{n}} Dateien nicht indiziert — die Vertraulichkeitsbezeichnung verbietet es",
    "refusedCountSingular": "{{n}} Datei nicht indiziert",
    "refusedCountPlural": "{{n}} Dateien nicht indiziert",
    "errorCountSingular": "{{n}} Fehler",
    "errorCountPlural": "{{n}} Fehler",
    "retryFailedPagesSingular": "{{n}} fehlgeschlagene Seite erneut versuchen",
    "retryFailedPagesPlural": "{{n}} fehlgeschlagene Seiten erneut versuchen",
    "labelled": "gekennzeichnet",
    "retrying": "Neuer Versuch…",
    "retry": "Erneut versuchen",
    "finalisingDetail": "Wird finalisiert — überprüft, dass keine weiteren Seiten vorhanden sind, dann wird der Auftrag geschlossen…",
    "scanningSource": "Quelle wird gescannt…",
    "sourcePages": "Quelleseiten",
    "sourcePageNote": "Quelleseiten gescannt ≠ hinzugefügte Elemente. Elementzahlen (+neu ~aktualisiert =unverändert) accumeln sich nach Abschluss jedes Batches.",
    "processing": "Wird verarbeitet…",
    "processingProgress": "Wird verarbeitet… {{processed}} / {{total}}",
    "starting": "Wird gestartet… warte auf ersten Batch",
    "waitingForWorker": "Warte darauf, dass Worker den Auftrag aufnimmt…",
    "stoppedBy": "Gestoppt von {{user}} — bereits aufgenommene Seiten werden beibehalten",
    "user": "Benutzer"
  },
  "newSkill": {
    "skillCreated": "Fähigkeit “{{name}}” erstellt",
    "skillImported": "“{{name}}” importiert",
    "noSkillFilesFound": "Keine .md-Fähigkeitsdateien in diesem Repository gefunden",
    "couldNotQueryGitHub": "Konnte GitHub nicht abfragen",
    "couldNotFetchSkill": "Konnte Fähigkeit nicht von GitHub abrufen",
    "invalidRef": "Ungültige Referenz — verwenden Sie owner/repo/path/to/file.md",
    "couldNotFetchFile": "Konnte Datei nicht von GitHub abrufen",
    "pageTitle": "Neue Fähigkeit",
    "createTab": "Erstellen",
    "importTab": "Von GitHub importieren",
    "nameLabel": "Name *",
    "namePlaceholder": "code-review",
    "versionLabel": "Version",
    "descriptionLabel": "Beschreibung",
    "descriptionPlaceholder": "Kurzbeschreibung dieser Fähigkeit",
    "contentLabel": "Inhalt *",
    "categoriesLabel": "Kategorien",
    "extraTagsLabel": "Zusätzliche Tags",
    "optional": "(optional)",
    "visibilityLabel": "Sichtbarkeit",
    "pasteAnyOf": "Fügen Sie einen davon ein:",
    "pasteUrlPlaceholder": "GitHub-URL oder owner/repo/path einf…",
    "searchSpecificDirectory": "In bestimmtem Verzeichnis suchen",
    "customSearchPlaceholder": "z.B. agents/ oder .claude/skills",
    "readyToImport": "Bereit zum Importieren",
    "categoriesLabelImport": "Kategorien",
    "optionalAddsToImportedTags": "(optional, wird zu den importierten Tags hinzugefügt)",
    "visibilityAfterImport": "Sichtbarkeit nach Import",
    "importing": "Importieren...",
    "importButton": "Fähigkeit importieren",
    "contentPlaceholder": "# Fähigkeitsinhalt\n\nBeschreiben Sie hier die Fähigkeitsanweisungen, Eingabeaufforderungen oder Konfiguration…",
    "creating": "Wird erstellt…",
    "createButton": "Fähigkeit erstellen",
    "discovering": "Wird erkannt…",
    "loading": "Wird geladen…",
    "discoverButton": "Entdecken",
    "previewButton": "Vorschau",
    "searchButton": "Suchen",
    "notFoundSpecifyPath": "Nicht gefunden? Pfad angeben →",
    "importButtonLabel": "Fähigkeit importieren",
    "repoUrl": "Repo-URL",
    "directFileUrl": "Direkte Datei-URL",
    "foundFilesSingular": "{{n}} Fähigkeitsdatei gefunden — zur Vorschau anklicken",
    "foundFilesPlural": "{{n}} Fähigkeitsdateien gefunden — zur Vorschau anklicken"
  },
  "siloTimeline": {
    "mapNotGenerated": "Platform-Intelligence-Karte noch nicht generiert",
    "triggerSyncToBuild": "Starten Sie eine Synchronisierung, um sie zu erstellen.",
    "builtFromSnapshots": "Erstellt aus Ihren täglichen Snapshots — verschieben Sie einige mit `joyia memory sync git-log`, oder fügen Sie eine serverseitige Integration an.",
    "platformMap": "Platform-Intelligence-Karte",
    "historicalRecord": "Historischer Datensatz",
    "noSnapshotsYet": "Noch keine täglichen Snapshots. Starten Sie eine Synchronisierung, um mit der Erfassung zu beginnen.",
    "noSnapshotsPush": "Noch keine täglichen Snapshots. Verschieben Sie sie von Ihrem Projekt mit `joyia memory sync git-log`.",
    "seeded": "{{count}} Timeline-Elemente initialisiert",
    "seedTestData": "Testdaten initialisieren",
    "dailySnapshots": "Tägliche Snapshots",
    "windowDesc": "(30-Tage-Fenster, ältere Daten werden im historischen Datensatz komprimiert)",
    "timelineExplorer": "Timeline-Explorer",
    "updatedAgo": "Aktualisiert vor {{time}}",
    "noContentYet": "Noch kein Inhalt.",
    "daysAgoSingular": "vor {{n}} Tag",
    "daysAgoPlural": "vor {{n}} Tagen"
  },
  "syncConfig": {
    "dangerZone": "Gefahrenbereich",
    "resetStoreTitle": "Speicher zurücksetzen und neu starten",
    "resetStoreDesc": "Löscht alle eingelesenen Einträge und setzt die Synchronisierungsmarken zurück. Die Quellkonfiguration bleibt erhalten. Die nächste Synchronisierung liest alles von Neuem ein.",
    "resetRestartBtn": "Zurücksetzen und neu starten",
    "areYouSure": "Sind Sie sicher?",
    "resetting": "Wird zurückgesetzt …",
    "yesReset": "Ja, zurücksetzen",
    "rebuildIndexTitle": "Suchindex neu aufbauen",
    "rebuildIndexDesc": "Baut den semantischen Suchbaum aus den Einträgen neu auf, die bereits in diesem Silo liegen. Es wird nichts gelöscht und kein Inhalt geht verloren. Nutzen Sie dies, wenn die Suche nichts zurückgibt oder wenn eine Frage an dieses Silo antwortet, es sei „noch nicht durchsuchbar“, obwohl keine Synchronisierung läuft — dieser Zustand löst sich nicht von selbst. Nach einem großen Stapelimport ebenfalls sinnvoll.",
    "indexing": "Wird indexiert …",
    "queuing": "Wird eingereiht …",
    "rebuildIndexBtn": "Index neu aufbauen",
    "tokenHelp": {
      "confluence": "Ein Atlassian-API-Token erstellen",
      "jira": "Ein Atlassian-API-Token erstellen",
      "openwebui": "Einen API-Schlüssel in chat.joyia.p7s1.io erstellen (Settings → Account)",
      "gitlab": "Ein persönliches GitLab-Zugriffstoken erstellen",
      "github": "Ein persönliches GitHub-Zugriffstoken erstellen",
      "slack": "Eine Slack-App und ein Bot-Token erstellen",
      "teams": "Azure Portal → App registrations → Certificates & secrets",
      "sharepoint": "Azure Portal → App registrations → Certificates & secrets",
      "gdrive": "Google Cloud Console → Service Accounts → Keys"
    },
    "heading": "Synchronisierungskonfiguration",
    "syncHistory": "Synchronisierungsverlauf",
    "addSource": "Quelle hinzufügen",
    "addIngestSource": "Importquelle hinzufügen",
    "docAndTimelineConnectors": "Dokument- und Zeitverlaufs-Konnektoren",
    "phBaseUrl": "Basis-URL",
    "phApiToken": "API-Token",
    "phEmail": "E-Mail",
    "phGitlabUrl": "GitLab-Basis-URL (z. B. https://gitlab.com)",
    "phPersonalAccessToken": "Persönliches Zugriffstoken",
    "phProjectPaths": "Projektschlüssel bzw. -pfade (durch Komma getrennt, z. B. mygroup/myrepo)",
    "phEnvironments": "Umgebungen (optional, durch Komma getrennt, z. B. production,staging)",
    "phDatadogApiKey": "Datadog-API-Schlüssel",
    "createDatadogApiKey": "Einen Datadog-API-Schlüssel erstellen ↗",
    "phDatadogAppKey": "Datadog-Anwendungsschlüssel",
    "createDatadogAppKey": "Einen Datadog-Anwendungsschlüssel erstellen ↗",
    "phDatadogSiteDefault": "Site (Standard: datadoghq.eu)",
    "phServices": "Dienste (optional, durch Komma getrennt)",
    "phFilterTags": "Filter-Tags (optional, z. B. env:production)",
    "phGithubPatPlain": "Persönliches GitHub-Zugriffstoken",
    "phRepositories": "Repositories (durch Komma getrennt, z. B. owner/repo, owner/repo2)",
    "phPagerdutyKey": "PagerDuty-REST-API-Schlüssel",
    "phServiceIds": "Dienst-IDs (optional, durch Komma getrennt)",
    "phTeamIdsOptional": "Team-IDs (optional, durch Komma getrennt)",
    "phBotTokenXoxb": "Bot-User-OAuth-Token (xoxb-…)",
    "phChannelIdsLong": "Kanal-IDs (durch Komma getrennt, z. B. C0123456789, C9876543210)",
    "phWorkspaceLong": "Name des Arbeitsbereichs (optional, z. B. Acme Engineering)",
    "phTenantId": "Azure-AD-Tenant-ID",
    "phClientId": "Client-ID der App-Registrierung",
    "phClientSecret": "Client-Secret",
    "phTeamIds": "Team-IDs (durch Komma getrennt)",
    "phSiteId": "Site-ID (oder leer lassen und unten die Site-URL verwenden)",
    "phSiteUrl": "Site-URL (z. B. contoso.sharepoint.com:/sites/Engineering)",
    "resourceType": "Ressourcentyp:",
    "documentLibrary": "Dokumentbibliothek",
    "sharepointList": "SharePoint-Liste",
    "phListId": "Listen-ID",
    "phDriveIdLong": "Drive-ID (optional — standardmäßig die Dokumentbibliothek der Site)",
    "phFolderPathLong": "Ordnerpfad (optional — Unterordner, auf den die Synchronisierung begrenzt wird)",
    "phServiceAccountEmail": "E-Mail des Dienstkontos",
    "phPrivateKeyLong": "Privater Schlüssel (fügen Sie den vollständigen PEM-Schlüssel aus dem JSON des Dienstkontos ein)",
    "phFolderIdsLong": "Ordner-IDs (durch Komma getrennt — geben Sie jeden Ordner für die E-Mail des Dienstkontos frei)",
    "entireSpaces": "Ganze Bereiche",
    "phSpaceKeysLong": "Bereichsschlüssel (durch Komma getrennt, z. B. ENG, DOCS)",
    "importsEveryPage": "Importiert jede Seite in jedem aufgeführten Bereich.",
    "pageTrees": "Seitenbäume",
    "phPageIds": "Seiten-IDs (durch Komma getrennt)",
    "phProjectKeysLong": "Projektschlüssel (durch Komma getrennt, z. B. ENG, OPS)",
    "phIssueTypesLong": "Vorgangstypen (optional, durch Komma getrennt, z. B. Bug, Story)",
    "phJqlLong": "Eigenes JQL (optional — überschreibt die Projektschlüssel)",
    "scheduleAuto": "Automatische Synchronisierung planen",
    "every6h": "Alle 6 Std.",
    "every12h": "Alle 12 Std.",
    "every24h": "Alle 24 Std.",
    "every48h": "Alle 48 Std.",
    "cancel": "Abbrechen",
    "titleStopSync": "Synchronisierung beenden (der aktuelle Stapel wird noch abgeschlossen)",
    "titlePreviewPage": "Vorschau der zuletzt geänderten Seite",
    "titleDiscoverCount": "Die echte Seitenzahl durch Paginierung von Confluence ermitteln",
    "extractingWithAi": "Seite wird mit KI ausgelesen und zusammengefasst …",
    "openInConfluence": "In Confluence öffnen ↗",
    "looksGoodStartSync": "Sieht gut aus — vollständige Synchronisierung starten",
    "close": "Schließen",
    "tryAnotherPage": "Eine andere Seite versuchen",
    "phSpaceKeysShort": "Bereichsschlüssel (durch Komma getrennt)",
    "phProjectKeysShort": "Projektschlüssel (durch Komma getrennt)",
    "phIssueTypesShort": "Vorgangstypen (optional)",
    "phJqlShort": "Eigenes JQL (optional)",
    "phAccessTokenKeep": "Zugriffstoken (leer lassen, um das bestehende zu behalten)",
    "phApiKeyKeep": "API-Schlüssel (leer lassen, um den bestehenden zu behalten)",
    "phAppKeyKeep": "Anwendungsschlüssel (leer lassen, um den bestehenden zu behalten)",
    "phDatadogSite": "Site (z. B. datadoghq.eu)",
    "phGithubPat": "Persönliches GitHub-Zugriffstoken (leer lassen, um das bestehende zu behalten)",
    "phRestApiKey": "REST-API-Schlüssel (leer lassen, um den bestehenden zu behalten)",
    "phBotToken": "Bot-User-OAuth-Token (leer lassen, um das bestehende zu behalten)",
    "phChannelIds": "Kanal-IDs (durch Komma getrennt)",
    "phWorkspaceShort": "Name des Arbeitsbereichs (optional)",
    "phTenantIdKeep": "Azure-AD-Tenant-ID (leer lassen, um die bestehende zu behalten)",
    "phClientIdKeep": "Client-ID der App-Registrierung (leer lassen, um die bestehende zu behalten)",
    "phClientSecretKeep": "Client-Secret (leer lassen, um das bestehende zu behalten)",
    "noSitesFound": "Für diese Verbindung wurden keine Sites gefunden.",
    "phDriveIdShort": "Drive-ID (optional)",
    "phFolderPathShort": "Ordnerpfad (optional)",
    "browseFolders": "Ordner durchsuchen",
    "useThisFolder": "Diesen Ordner verwenden",
    "loading": "Wird geladen …",
    "emptyFolder": "Leerer Ordner.",
    "phServiceAccountEmailKeep": "E-Mail des Dienstkontos (leer lassen, um die bestehende zu behalten)",
    "phPrivateKeyKeep": "Privater Schlüssel (leer lassen, um den bestehenden zu behalten)",
    "phFolderIdsShort": "Ordner-IDs (durch Komma getrennt)",
    "enableWebhook": "Webhook-Import aktivieren",
    "noIngestSources": "Noch keine Importquellen konfiguriert",
    "addOpenwebuiOutputBtn": "OpenWebUI-Ausgabe hinzufügen",
    "addOpenwebuiOutput": "OpenWebUI-Ausgabe hinzufügen",
    "phOpenwebuiUrl": "Basis-URL (z. B. https://chat.joyia.p7s1.io)",
    "phApiKey": "API-Schlüssel",
    "phKnowledgeBaseIds": "IDs der Wissensdatenbanken (eine pro Zeile oder durch Komma getrennt)",
    "addOutput": "Ausgabe hinzufügen",
    "titleTriggerOutput": "Ausgabe-Synchronisierung jetzt starten",
    "noOutputs": "Noch keine Ausgaben konfiguriert",
    "deleteSilo": "Dieses Silo löschen",
    "deleteSiloBtn": "Silo löschen",
    "thisIsPermanent": "Das ist endgültig!",
    "deleting": "Wird gelöscht …",
    "testing": "Wird getestet…",
    "testConnection": "Verbindung testen",
    "pagerDutyPath": "In Ihrem PagerDuty-Konto: {{path}}",
    "recommendedOwnAccount": "Empfohlen: mit Ihrem eigenen Microsoft-Konto verbinden (kein Azure-Administrator nötig)",
    "orAppOnly": "Oder App-only-Authentifizierung manuell einrichten (ein Azure-AD-Administrator muss Sites.Selected-Zugriff erteilen):",
    "copyListId": "Erforderlich. Kopieren Sie die Listen-ID aus SharePoint oder dem Microsoft Graph Explorer.",
    "askToVerify": "Stellen Sie eine Frage zu dieser Seite, um zu prüfen, ob die KI sie verstanden hat:",
    "fetchingConfluence": "Seite wird von Confluence abgerufen und per KI zusammengefasst…",
    "pickSiteFirst": "Wählen Sie zuerst oben eine Site oder geben Sie eine Site-ID bzw. -URL ein.",
    "deleteSiloWarning": "Löscht das Silo, alle Einträge, die Synchronisationskonfiguration und die Wissensgraph-Knoten unwiderruflich. Das kann nicht rückgängig gemacht werden.",
    "raptorRebuildQueued": "RAPTOR-Indexneuerstellung in Warteschlange – überprüfen Sie die Synchronisierungsverlauf für Fortschritt",
    "rebuildFailed": "Neuerstellung fehlgeschlagen: {{error}}",
    "syncCancelled": "Synchronisierung abgebrochen – aktueller Batch wird beendet und stoppt dann",
    "cancelFailed": "Abbruch fehlgeschlagen: {{error}}",
    "resetComplete": "Zurücksetzen abgeschlossen – {{deletedItems}} Elemente gelöscht, {{sourcesReset}} Quelle(n) geleert. Lösen Sie eine vollständige Synchronisierung aus, um erneut aufzunehmen.",
    "resetFailed": "Zurücksetzen fehlgeschlagen: {{error}}",
    "syncFailed": "Synchronisierung fehlgeschlagen: {{error}}",
    "outputSyncQueued": "Ausgabesynchronisierung in Warteschlange",
    "outputSyncFailed": "Ausgabesynchronisierung fehlgeschlagen: {{error}}",
    "sourceAdded": "Quelle hinzugefügt",
    "failedToAddSource": "Fehler beim Hinzufügen der Quelle: {{error}}",
    "sourceRemoved": "Quelle entfernt",
    "failedToRemoveSource": "Fehler beim Entfernen der Quelle: {{error}}",
    "sourceUpdated": "Quelle aktualisiert",
    "failedToUpdateSource": "Fehler beim Aktualisieren der Quelle: {{error}}",
    "enterBaseUrlAndApiKeyFirst": "Bitte geben Sie zuerst Base URL und API-Schlüssel ein.",
    "connectedFoundKbsWithNames": "Verbunden! {{count}} Wissensbasis(n) gefunden: {{names}}",
    "connectedFoundKbs": "Verbunden! {{count}} Wissensbasis(n) gefunden.",
    "connectionFailed": "Verbindung fehlgeschlagen: {{error}}",
    "outputAdded": "Ausgabe hinzugefügt",
    "failedToAddOutput": "Fehler beim Hinzufügen der Ausgabe: {{error}}",
    "outputRemoved": "Ausgabe entfernt",
    "failedToRemoveOutput": "Fehler beim Entfernen der Ausgabe: {{error}}",
    "discoverFailed": "Ermittlung fehlgeschlagen: {{error}}",
    "previewFailed": "Vorschau fehlgeschlagen: {{error}}",
    "askFailed": "Anfrage fehlgeschlagen: {{error}}",
    "descSpaces": "Bereiche: {{keys}}",
    "descProjects": "Projekte: {{keys}}",
    "descJql": "JQL: {{jql}}…",
    "descServices": "Dienste: {{services}}",
    "descRepos": "Repositories: {{repos}}",
    "descTeams": "Teams: {{teams}}",
    "descChannels": "Kanäle: {{channels}}",
    "descSyncedViaCli": "Synchronisiert über Joyia CLI (joyia memory sync)",
    "descList": "Liste: {{listId}}",
    "descListNoId": "Liste (keine Listen-ID gesetzt)",
    "descFolder": "Ordner: {{folderPath}}",
    "descNoSiteConfigured": "Keine Site konfiguriert",
    "descFolders": "Ordner: {{folders}}",
    "descNoFoldersConfigured": "Keine Ordner konfiguriert",
    "descNoUrlConfigured": "Keine URL konfiguriert",
    "disableScheduledSync": "Geplante Synchronisierung deaktivieren",
    "enableScheduledSync": "Geplante Synchronisierung aktivieren",
    "schedule": "Zeitplan",
    "cancelEdit": "Bearbeitung abbrechen",
    "editSource": "Quelle bearbeiten",
    "incrementalSyncTitle": "Inkrementelle Synchronisierung (nur Änderungen)",
    "fullSyncTitle": "Vollständige Synchronisierung",
    "syncAlreadyRunning": "Synchronisierung wird bereits ausgeführt",
    "forceFullResync": "Vollständige Neuensynchronisierung erzwingen (alle Seiten)",
    "rawExcerptAiUnavailable": "Rohexzerpt (KI nicht verfügbar)",
    "aiSummary": "KI-Zusammenfassung",
    "phAskPageQuestion": "z. B. Welches ist das Hauptthema dieser Seite?",
    "webhookUrlCopied": "Webhook-URL kopiert",
    "copy": "Kopieren",
    "yesDelete": "Ja, löschen",
    "totalPages": "Gesamt: {{total}} Seiten"
  },
  "connector": {
    "confluenceDesc": "Seiten und Bereiche",
    "jiraDesc": "Vorgänge und Projekte",
    "openwebuiDesc": "Wissensdatenbank",
    "gitlabDesc": "Pipelines, Merge Requests und Bereitstellungen",
    "datadogDesc": "Monitore und Ereignisse",
    "githubDesc": "Actions, Pull Requests und Releases",
    "pagerdutyDesc": "Vorfälle und Rufbereitschaft",
    "slackDesc": "Kanalzusammenfassungen und Diskussionen",
    "teamsDesc": "Kanalaktivität",
    "local": "Lokal / CLI",
    "localDesc": "Projektdateien über die joyia-CLI",
    "sharepointDesc": "Dokumentbibliotheken",
    "gdriveDesc": "Docs, Sheets und Slides",
    "confluence": "Confluence",
    "jira": "Jira",
    "openwebui": "OpenWebUI",
    "gitlab": "GitLab",
    "datadog": "Datadog",
    "github": "GitHub",
    "pagerduty": "PagerDuty",
    "slack": "Slack",
    "teams": "MS Teams",
    "sharepoint": "SharePoint",
    "gdrive": "Google Drive"
  },
  "siloTree": {
    "syncing": "Wird synchronisiert …",
    "treeStats": "Baumstatistik",
    "totalNodes": "Knoten insgesamt",
    "layers": "Ebenen",
    "leafNodes": "Blattknoten",
    "summaries": "Zusammenfassungen",
    "legend": "Legende",
    "leafChunk": "Blatt-Abschnitt",
    "treeExplorer": "Baum-Explorer",
    "loadingTree": "Baum wird geladen …",
    "failedToLoad": "Der Baum konnte nicht geladen werden",
    "retry": "Wiederholen",
    "noTreeYet": "Noch kein RAPTOR-Baum erstellt",
    "triggerSync": "Starten Sie eine Synchronisierung, um den semantischen Index zu erstellen.",
    "goToSilo": "Zum Silo",
    "summarisedFrom_one": "Zusammengefasst aus {{count}} Knoten",
    "summarisedFrom_other": "Zusammengefasst aus {{count}} Knoten",
    "childCountSingular": "{{n}} Unterknoten",
    "childCountPlural": "{{n}} Unterknoten",
    "nodesAndLayers": "{{nodes}} Knoten · {{layers}} Ebenen"
  },
  "createItem": {
    "addItem": "Wissenseintrag hinzufügen",
    "title": "Titel *",
    "phTitle": "Titel des Eintrags",
    "content": "Inhalt",
    "phContent": "Markdown wird unterstützt …",
    "knowledgeType": "Wissenstyp",
    "typeAuto": "Automatisch erkennen",
    "typeFactual": "Faktisch — Referenzdokumente, stabile Fakten",
    "typeProcedural": "Prozedural — Runbooks, Anleitungen",
    "typeTemporal": "Zeitbezogen — zeitgebundene Ereignisse, Momentaufnahmen",
    "typeRelational": "Relational — Abhängigkeiten, Architektur",
    "typeContextual": "Kontextuell — aktueller Zustand, Vorfälle",
    "typeSocial": "Sozial — Teamstruktur, Zuständigkeiten",
    "typePolicy": "Richtlinien — Compliance, SLAs, Governance",
    "typeMeta": "Meta — Zusammenfassungen, Indizes",
    "tags": "Tags (durch Komma getrennt)",
    "suggestTags": "Tags per KI aus Titel und Inhalt vorschlagen"
  },
  "createSilo": {
    "startingLayout": "Ausgangslayout",
    "change": "Ändern",
    "tags": "Tags (durch Komma getrennt)",
    "publicSilo": "Öffentliches Silo",
    "publicSiloDesc": "Alle Personen in Ihrer Organisation können dieses Silo lesen",
    "guardrailProfiles": "Schutzprofile",
    "guardrailDesc": "Wird auf alle LLM-Aufrufe angewendet, die den Inhalt dieses Silos verarbeiten",
    "cancel": "Abbrechen",
    "creating": "Wird erstellt…",
    "create": "Silo erstellen",
    "createFailed": "Silo konnte nicht erstellt werden: {{message}}"
  },
  "errorBoundary": {
    "somethingWrong": "Etwas ist schiefgelaufen",
    "unexpected": "Ein unerwarteter Fehler ist aufgetreten",
    "tryAgain": "Erneut versuchen",
    "goHome": "Zur Startseite"
  },
  "siloShare": {
    "private": "Privat",
    "privateDesc": "Nur Sie haben Zugriff",
    "restricted": "Eingeschränkt",
    "restrictedDesc": "Personen, die Sie einladen",
    "tribe": "Tribe",
    "tribeDesc": "Alle Mitglieder eines Tribes",
    "orgVisible": "Organisationsweit sichtbar",
    "orgVisibleDesc": "Alle in Ihrer Organisation",
    "shareSilo": "Silo teilen",
    "controlAccess": "Legen Sie fest, wer auf dieses Wissenssilo zugreifen darf.",
    "visibility": "Sichtbarkeit",
    "selectTribes": "Wählen Sie die Tribes, die dieses Silo sehen dürfen",
    "noTribes": "Keine Tribes verfügbar",
    "selectAtLeastOne": "Wählen Sie mindestens einen Tribe aus, um zu speichern",
    "pendingRequests": "Offene Anfragen",
    "approve": "Genehmigen",
    "deny": "Ablehnen",
    "peopleWithAccess": "Personen mit Zugriff",
    "emailAddress": "E-Mail-Adresse",
    "roleViewer": "Lesend",
    "roleEditor": "Bearbeitend",
    "invite": "Einladen",
    "youOwner": "Sie (Inhaberin bzw. Inhaber)",
    "owner": "Inhaber",
    "removeMember": "Mitglied entfernen",
    "noMembers": "Noch keine weiteren Mitglieder. Laden Sie oben jemanden ein."
  },
  "globalChat": {
    "suggestConnectSource": "Wie verbinde ich eine Quelle?",
    "suggestSiloVsSkill": "Was ist der Unterschied zwischen einem Silo und einem Skill?",
    "askAi": "KI fragen",
    "askKnowledgeBase": "Fragen Sie Ihre Wissensdatenbank",
    "liveAccess": "Live-Zugriff:",
    "askAboutKf": "Fragen zu Knowledgeflow",
    "verifyBeforeActing": "Die Antworten stammen aus der Dokumentation — prüfen Sie sie immer, bevor Sie handeln.",
    "closeChat": "Chat schließen",
    "phAskKf": "Fragen Sie etwas zu Knowledgeflow … (Enter zum Senden)",
    "clearConversation": "Unterhaltung löschen",
    "yourKnowledge": "Ihr Wissen",
    "help": "Hilfe",
    "thisSilo": "Dieses Silo",
    "allSilos": "Alle Silos",
    "searchingWithinThisSilo": "Suche in diesem Silo",
    "searchingAcrossAllSilos": "Suche in allen Silos",
    "suggestMonitorsAlerting": "Welche Monitore sind aktiv?",
    "suggestRecentEvents": "Aktuelle Ereignisse anzeigen",
    "suggestOpenMergeRequests": "Offene Merge Requests anzeigen",
    "suggestRecentPipelineStatus": "Aktueller Pipeline-Status",
    "suggestIssuesInProgress": "Welche Issues sind in Bearbeitung?",
    "suggestTopicsCovered": "Welche Themen werden behandelt?",
    "suggestFindRecentItems": "Aktuelle Elemente suchen",
    "suggestSummarizeSilo": "Dieses Silo zusammenfassen",
    "phAskAllSilos": "In allen Silos fragen… (Eingabe zum Senden)",
    "contentPolicies": "Inhaltsrichtlinien",
    "contentPoliciesActive": "Inhaltsrichtlinien (aktiv)",
    "answerFromDocs": "Ich antworte aus der Knowledgeflow-Dokumentation."
  },
  "knowledgeChat": {
    "searchResultSingular": "{{n}} Ergebnis für “{{query}}”",
    "searchResultPlural": "{{n}} Ergebnisse für “{{query}}”"
  },
  "inlineTable": {
    "rowCountSingular": "{{n}} Zeile",
    "rowCountPlural": "{{n}} Zeilen",
    "showMoreSingular": "{{n}} weitere Zeile anzeigen",
    "showMorePlural": "{{n}} weitere Zeilen anzeigen",
    "showLess": "Weniger anzeigen"
  },
  "bundledFiles": {
    "heading": "Gebündelte Dateien",
    "phContents": "Dateiinhalt…",
    "skippedSingular": "{{n}} Datei übersprungen — nur Textdateien können veröffentlicht werden.",
    "skippedPlural": "{{n}} Dateien übersprungen — nur Textdateien können veröffentlicht werden.",
    "read": "{{file}} gelesen",
    "readAndMore": "{{file}} und {{n}} weitere gelesen"
  },
  "skillDropzone": {
    "plusFileSingular": "+ {{n}} Datei",
    "plusFilePlural": "+ {{n}} Dateien"
  },
  "skillCard": {
    "viewSkill": "Skill ansehen",
    "bundlesSingular": "Enthält {{n}} Datei neben SKILL.md",
    "bundlesPlural": "Enthält {{n}} Dateien neben SKILL.md",
    "fileCountSingular": "{{n}} Datei",
    "fileCountPlural": "{{n}} Dateien"
  },
  "carousel": {
    "prevSlide": "Vorheriges Bild",
    "nextSlide": "Nächstes Bild"
  },
  "agentElement": {
    "maxTurns": "Max. Züge"
  },
  "collab": {
    "settings": "Collab-Einstellungen",
    "approvalMode": "Zustimmungsmodus",
    "maxTurnsPerPersona": "Maximale Züge pro Persona",
    "resetCounter": "Zugzähler zurücksetzen",
    "reset": "Zurücksetzen"
  },
  "connectionStatus": {
    "offline": "Keine Verbindung. Die Zahlen können nicht aktualisiert werden, bis Sie wieder online sind.",
    "reload": "Neu laden"
  },
  "helpAnswer": {
    "sources": "Quellen"
  },
  "helpWidget": {
    "clearAria": "Unterhaltung löschen",
    "clear": "Unterhaltung löschen",
    "closeAria": "Hilfe schließen",
    "reading": "Die Dokumentation wird gelesen…",
    "verifyNote": "Die Antworten stammen aus der Dokumentation – prüfen Sie sie immer, bevor Sie handeln.",
    "productHelp": "{{product}}-Hilfe",
    "productHelpDrag": "{{product}}-Hilfe — zum Verschieben ziehen",
    "answersFromDocs": "Antworten aus der {{product}}-Dokumentation",
    "askAbout": "Fragen zu {{product}}",
    "askAboutDetail": "Ich antworte aus der {{product}}-Dokumentation und kann dich zur richtigen Stelle leiten.",
    "askAboutPlaceholder": "Fragen zu {{product}}…",
    "notAvailableYet": "Hilfe ist hier noch nicht verfügbar.",
    "somethingWentWrong": "Es ist etwas schiefgelaufen (HTTP {{status}}).",
    "requestFailed": "Die Anfrage ist fehlgeschlagen.",
    "couldNotRunAction": "Konnte nicht {{action}}."
  },
  "citation": {
    "prevAria": "Zurück",
    "nextAria": "Weiter"
  },
  "installPrompt": {
    "notNowAria": "Jetzt nicht",
    "iosPath": "Share → Add to Home Screen",
    "showMeHow": "Zeig mir, wie",
    "install": "Installieren"
  },
  "messageEditor": {
    "cancel": "Abbrechen"
  },
  "message": {
    "copy": "Nachricht kopieren",
    "regenerate": "Antwort neu erzeugen",
    "edit": "Nachricht bearbeiten",
    "goodResponse": "Gute Antwort",
    "poorResponse": "Schlechte Antwort"
  },
  "plan": {
    "toggle": "Plan umschalten"
  },
  "promptInput": {
    "removeAttachment": "Anhang entfernen"
  },
  "reasoning": {
    "thinking": "Denkt nach…",
    "thoughtFor": "Hat einige Sekunden nachgedacht",
    "thoughtForSeconds_one": "Hat {{count}} Sekunde nachgedacht",
    "thoughtForSeconds_other": "Hat {{count}} Sekunden nachgedacht"
  },
  "tool": {
    "streaming": "Wird übertragen",
    "running": "Läuft",
    "approvalRequired": "Zustimmung erforderlich",
    "approved": "Genehmigt",
    "completed": "Abgeschlossen",
    "denied": "Abgelehnt",
    "error": "Fehler",
    "pending": "Ausstehend"
  }
}
